// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import Home from './components/Views/Shared/Home';
import ConsumerLogin from './components/Views/Consumer/ConsumerLogin';
import Feedback from './components/Views/Shared/Feedback';
import  { ConsumerRegisterRouteWrapper } from './components/Views/Consumer/ConsumerRegister';
import ConsumerRegisterSuccess from './components/Views/Consumer/ConsumerRegisterSuccess';
import ConsumerRegisterFailure from './components/Views/Consumer/ConsumerRegisterFailure';
import RetrieveCredentials from './components/Views/Shared/RetrieveCredentials';
import RetrieveCredentialsFormRouteWrapper from './components/Views/Shared/RetrieveCredentialsForm';
import StartUserRegistering from './components/Views/Shared/StartUserRegistering';
import ConsumerDashboard from './components/Views/Consumer/ConsumerDashboard';
import DetailsPageWrapper from './components/Views/Shared/DetailsPage';
import ConsumerRegisterDetailsRouteWrapper from './components/Views/Consumer/ConsumerRegisterDetails';
import AccessForbidden from './components/Views/Shared/AccessForbidden';
import NotFound from './components/Views/Shared/NotFound';
import CompanyRegisterDetails from './components/Views/Company/CompanyRegisterDetails';
import ConsumerContracts from './components/Views/Consumer/Contracts/ConsumerContracts';
import ContactDetailsForm from './components/Views/Shared/ContactDetailsForm';
import RopoDetails from './components/Views/Consumer/Invoices/RopoDetails';
import B2BRegister from './components/Views/Shared/B2BRegister';
import CompanyDashboard from './components/Views/Company/CompanyDashboard';
import CompanyLogin from './components/Views/Company/CompanyLogin';
import CompanyInvoiceDetails from './components/Views/Company/CompanyInvoiceView';

// TODO Determine if props are needed here or not.
const AppRoutes = () => {
  return (
    <Routes>
      {/* Consumer routes */}
      <Route path="/kirjaudu" Component={ConsumerLogin} />
      <Route path="/rekisteroidy" Component={ConsumerRegisterRouteWrapper} />
      <Route path="/rekisteroidy/virhe" Component={ConsumerRegisterFailure} />
      <Route path="/rekisteroidy/aloita" Component={StartUserRegistering} />
      <Route path="/rekisteroidy/tiedot" Component={ConsumerRegisterDetailsRouteWrapper} />
      <Route path="/rekisteroidy/pyynto" Component={B2BRegister} />
      <Route path="/dashboard" Component={ConsumerDashboard} />

      <Route path="/laskutustiedot" Component={RopoDetails} />
      <Route path="/yritys/laskutustiedot" Component={CompanyInvoiceDetails} />
      <Route path="/sopimukset" Component={ConsumerContracts} />
      <Route path="/yhteystiedot" Component={ContactDetailsForm} />
      <Route path="/sahko/:itemId/:initialDate?" Component={DetailsPageWrapper} />
      <Route path="/vesi/:itemId" Component={DetailsPageWrapper} />
      <Route path="/kaukolampo/:itemId" Component={DetailsPageWrapper} />
      <Route path="/rekisteroidy/success" Component={ConsumerRegisterSuccess} />
      <Route path="/rekisteroidy/virhe" Component={ConsumerRegisterFailure} />
      {/* Company routes */}
      <Route path="/yritys/kirjaudu" Component={CompanyLogin} />
      <Route path="/yritys/yleisnakyma" Component={CompanyDashboard} />
      <Route path="/yritys/rekisteroidy/tiedot" Component={CompanyRegisterDetails} />
      <Route path="/yritys/sahko/:itemId/:companyId" Component={DetailsPageWrapper} />
      <Route path="/yritys/kaukolampo/:itemId/:companyId" Component={DetailsPageWrapper} />
      {/* Common routes */}
      <Route path="/" Component={Home} />
      <Route path="/feedback" Component={Feedback} />
      <Route path="/palauta" Component={RetrieveCredentials} />
      <Route path="/tunnus/virhe" Component={ConsumerRegisterFailure} />
      <Route path="/tunnus" Component={RetrieveCredentialsFormRouteWrapper} />
      {/* Pass through all server api routes */}
      <Route path="/api" />
      {/* 403 route */}
      <Route path="/forbidden" Component={AccessForbidden} />
      {/* Catch all unmatched */}
      <Route Component={NotFound} />
    </Routes>
  );
};

export default inject('LoginStore')(observer(AppRoutes));
